export enum NovapostPaymentMethodEnum {
    CASH = 'Cash',
    NON_CASH = 'NonCash'
}
